import { toast } from './toast';
import { FormGroup } from '@angular/forms';

export function tratarErro(error: any, semToast?: boolean) {
  console.log(error);
  const buttons = [
    {
      text: 'OK',
      role: 'cancel'
    }
  ];
  let mensagem = 'Tente novamente mais tarde';
  if (error.error && error.error.mensagem) {
    mensagem = error.error.mensagem;
  } else if (typeof error === 'string') {
    mensagem = error;
  }
  if (semToast) return mensagem;
  toast(mensagem, 999999999, 'top', buttons);
}

export function validarFormulario(form: FormGroup) {
  Object.keys(form.controls).map(k => form.get(k)).forEach(c => c.updateValueAndValidity());
  return form;
}

export function b64toArrayBuffer(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return ia;
}


export function b64toBlob(dataURI, mimetype) {
  return new Blob([b64toArrayBuffer(dataURI)], {
    type: mimetype
  });
}

export function limparStrings(valores) {
  if (valores === null || valores === undefined) {
    return valores;
  }
  if (Array.isArray(valores)) {
    return valores.map((item) => limparStrings(item));
  }
  if (typeof valores === 'object') {
    Object.keys(valores).map(k => valores[k] = limparStrings(valores[k]));
    return valores;
  }
  if (typeof valores === 'string') {
    return valores.trim();
  }

  return valores;
}

